import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitch-brands",
  "use": "twitch-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"twitch-brands\"><path d=\"M2.148 0L.536 4.12v16.837h5.732V24h3.225l3.043-3.043h4.66l6.268-6.268V0H2.148zm19.168 13.613l-3.584 3.583H12L8.957 20.24v-3.043H4.12V2.148h17.196v11.465zm-3.584-7.345v6.262h-2.148V6.268h2.148zm-5.732 0v6.262H9.852V6.268H12z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol